// extracted by mini-css-extract-plugin
export default {"zone":"c8hGwT5D","leftArrow":"N1teMnBr","gallery":"gallery","rightArrow":"nWiZm0Ip","fullscreen":"JZrVK5zN","disabledZone":"ILJG3It0"};